import React from 'react';
import { useSearchParams } from 'react-router-dom';
import {ReactComponent as LogoBrandmark} from "../assets/images/logo-new-brandmark.svg";
import Layout from "../components/common/Layout";
import LoginForm from "../components/forms/LoginForm";
import styles from "../styles/common/Login.module.scss";

const Login = () => {
  const [searchParams] = useSearchParams();
  const isNewUser = searchParams.get('new_user') === 'true';
  const prefilledEmail = searchParams.get('email')?.replace(/ /g, '+') || '';

  return (
    <Layout
      pageTitle="Login - Liquid Credit"
      hideHeader
      pageBodyClassName={styles.loginPage}
    >
      <div className={styles.loginContainer}>
        <div className={styles.logoContainer}>
          <div className={styles.logoIcon}>
            <LogoBrandmark />
          </div>
          <span className={styles.logoText}>Liquid Credit</span>
        </div>

        {isNewUser && (
          <div className={styles.welcomeBanner}>
            <div className={styles.welcomeIcon}>
              🎉
            </div>
            <div className={styles.welcomeContent}>
              <h3 className={styles.welcomeTitle}>Welcome to Liquid Credit!</h3>
              <p className={styles.welcomeMessage}>
                Great to have you on board! After signing in, we'll walk you through a quick onboarding process to get your account set up.
              </p>
            </div>
          </div>
        )}

        <div className={styles.loginCard}>
          <div className={styles.loginHeader}>
            <h2 className={styles.loginTitle}>
              {isNewUser ? 'Welcome to Liquid Credit' : 'Welcome to Liquid Credit'}
            </h2>
            <p className={styles.loginSubtitle}>
              {isNewUser 
                ? 'Sign in to complete your account setup'
                : 'Sign in to access your credit management dashboard'
              }
            </p>
          </div>

          <LoginForm prefilledEmail={prefilledEmail} />
          
          <div className={styles.supportLink}>
            <span>Need access to Liquid Credit? </span>
            <a href="mailto:support@liquidcredit.co" className={styles.contactLink}>
              Contact Support
            </a>
          </div>
        </div>

        <div className={styles.securityNotice}>
        All transactions on Liquid Credit protected by enterprise-grade security.
        </div>
      </div>
    </Layout>
  );
};

export default Login;
